const updateDynamicFieldView = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (datasource === 'gumbo') {
        const allPlays = action.data?.liveData?.plays?.allPlays;
        const timeStamp = allPlays[allPlays.length - 1]?.playEndTime;
        const { gamePk } = action.data;
        return {
            ...state,
            playTimeStamp: timeStamp,
            gamePk
        };
    }
    return state;
};

export default updateDynamicFieldView;
